import React, { CSSProperties, HTMLProps } from "react";
import styled from "styled-components";

type HTMLAnchorProps = Omit<HTMLProps<HTMLAnchorElement>, "as" | "prefix" | "size">;

interface Props extends HTMLAnchorProps {
	title: string;
	src: string;
	ariaLabel?: string;
	className?: string;
	style?: CSSProperties;
}

const StyledAnchor = styled.a`
	cursor: pointer;
`;

const Image = styled.img`
	width: 100%;
	height: 50px;
`;

export const ImageAnchorButton = React.forwardRef<HTMLAnchorElement, Props>(function Button({ src, ...rest }, ref) {
	return (
		<StyledAnchor {...rest} ref={ref}>
			<Image src={src} />
		</StyledAnchor>
	);
});
